var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396 40h-40V0H156v40h-40c-33.084 0-60 26.916-60 60v352c0 33.084 26.916 60 60 60h280c33.084 0 60-26.916 60-60V100c0-33.084-26.916-60-60-60zm-200 0h120v20c0 11.028-8.972 20-20 20h-80c-11.028 0-20-8.972-20-20zm220 412c0 11.028-8.972 20-20 20H116c-11.028 0-20-8.972-20-20V100c0-11.028 8.972-20 20-20h43.44c8.256 23.278 30.487 40 56.56 40h80c26.073 0 48.303-16.722 56.56-40H396c11.028 0 20 8.972 20 20z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 196h40v40h-40zM336 276h40v40h-40zM336 356h40v40h-40zM136 196h160v40H136zM136 276h160v40H136zM136 356h160v40H136z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceList);
export default __webpack_public_path__ + "static/media/price-list.62032bd3a2e99cbb59f8cfb39dcd3a3c.svg";
export { ForwardRef as ReactComponent };